import {useEffect, useState} from 'react';
import {Pages} from './assets/ts/customTypes';
import {Header} from './lib/components/Header';
import {Landingpage} from './lib/pages/Landingpage';
import { Infopage } from './lib/pages/Infopage';
import { useMatomo } from '@jonkoops/matomo-tracker-react';
import { ProcessPage } from './lib/pages/ProcessPage';
import { TestimonialsPage } from './lib/pages/TestimonialsPage';
import { ContactPage } from './lib/pages/ContactPage';
import { Navigation } from './lib/components/Navigation';
import { LanguageContextProvider } from './lib/contexts/LanguageContext';
import { isInIframe } from './config';
import { InfoLayer } from './lib/components/Infolayer';

export function App() {
    const [currentPage, setCurrentPage] = useState<Pages>(Pages.LANDINGPAGE);

    const { trackPageView } = useMatomo();

    useEffect(() => {
        trackPageView({
            documentTitle: 'Home'
        });
    }, [trackPageView]);

    return (
        <LanguageContextProvider>
            {!isInIframe && <Header />}
            <InfoLayer />
            {showPage()}
            {[
                // Pages to use footer navigation
                Pages.LAGERERGAENZUNG,
                Pages.TEILEIDENTIFIKATION,
                Pages.BESTELLSCHNITTSTELLE,
                Pages.KATALOGSCHNITTSTELLE,
                Pages.NETTOPREISSCHNITTSTELLE,
                Pages.VERFUEGBARKEITSSCHNITTSTELLE,
            ].includes(currentPage) && <Navigation
                currentPage={currentPage}
                onChangePage={setCurrentPage}
            />}
        </LanguageContextProvider>
    );

    function showPage() {
        switch (currentPage) {
            case Pages.LANDINGPAGE:
                return <Landingpage onChangePage={onChangePage} />;
            case Pages.TEILEIDENTIFIKATION:
                return <ProcessPage page={Pages.TEILEIDENTIFIKATION} />;
            case Pages.LAGERERGAENZUNG:
                return <ProcessPage page={Pages.LAGERERGAENZUNG} />;
            case Pages.KUNDENZITATE:
                return <TestimonialsPage page={Pages.KUNDENZITATE} onChangePage={onChangePage} />;
            case Pages.KONTAKT:
                return <ContactPage page={Pages.KONTAKT} onChangePage={onChangePage} />;
            default:
                // if (language === de) {
                //     trackPageView({
                //         documentTitle: currentPage,
                //         href: 'https://eprocurement.omniplus.com/' + currentPage,
                //     });
                // };
                return (
                    <Infopage page={currentPage} />
                );
        }
    }

    function onChangePage(page: Pages) {
        setCurrentPage(page);
    }
}
